import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export const formatDate = (dateString: string): string => {
  const date = dayjs(dateString);
  return date.format('MMMM D, YYYY, hh:mm A');
};

export const formatChatTime = (dateString: string): string => {
  const date = dayjs(dateString);
  const now = dayjs();
  
  if (date.isSame(now, 'day')) {
    return date.format('h:mm A');
  }
  
  if (date.isSame(now.subtract(1, 'day'), 'day')) {
    return `Yesterday ${date.format('h:mm A')}`;
  }
  
  if (date.isAfter(now.subtract(7, 'day'))) {
    return date.format('ddd h:mm A');
  }
  
  return date.format('MMM D, h:mm A');
};

export const formatWordCount = (count: number): string => {
  if (count < 1000) {
    return `${count} words`;
  }
  return `${(count / 1000).toFixed(1)}k words`;
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
};

export const getReadingTime = (wordCount: number): string => {
  const wordsPerMinute = 200;
  const minutes = Math.ceil(wordCount / wordsPerMinute);
  return `${minutes} min read`;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};

export const downloadAsFile = (content: string, filename: string, type: string = 'text/plain') => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadChatHistory = (messages: any[], filename: string = 'chat-history.txt') => {
  const chatContent = messages
    .map(message => {
      const time = formatDate(message.timestamp);
      const sender = message.type === 'user' ? 'You' : 'Assistant';
      return `[${time}] ${sender}: ${message.content}`;
    })
    .join('\n\n');
  
  downloadAsFile(chatContent, filename);
};

export const generateChatId = (): string => {
  return `chat_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

export const sanitizeQuestion = (question: string): string => {
  return question.trim().replace(/\s+/g, ' ');
};

export const isValidQuestion = (question: string): boolean => {
  const sanitized = sanitizeQuestion(question);
  return sanitized.length > 0 && sanitized.length <= 500;
};